import {updateUrl} from '@github-ui/history'
import {on} from 'delegated-events'

on(
  'click',
  '.js-actions-runner-platform-radio',
  function (event) {
    const target = event.target as Element
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const selection = target.closest<HTMLElement>('.js-actions-runner-instructions')!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const architectureMenu = selection.querySelector<HTMLElement>('.js-actions-runner-architecture-menu')!

    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const os = target.getAttribute('data-download-os')!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const defaultArchitecture = architectureMenu.getAttribute('data-default-architecture')!

    for (const el of architectureMenu.querySelectorAll<HTMLElement>('[data-download-os]')) {
      /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
      const elementOS = el.getAttribute('data-download-os')!
      el.hidden = elementOS !== os
      if (elementOS === os && el.getAttribute('data-download-architecture') === defaultArchitecture) {
        el.click()
      }
    }
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    selection.querySelector<HTMLElement>('.js-actions-runner-windows-instructions')!.hidden = os !== 'win'
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    selection.querySelector<HTMLElement>('.js-actions-runner-windows-arm64-preview')!.hidden = !(
      os === 'win' && defaultArchitecture === 'arm64'
    )
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    selection.querySelector<HTMLElement>('.js-actions-runner-unix-instructions')!.hidden = os === 'win'
    updateUrlParams('os', os)
  },
  {capture: true},
)

on(
  'details-menu-selected',
  '.js-actions-runner-architecture-menu',
  function (event) {
    const target = event.detail.relatedTarget as Element
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const selection = target.closest<HTMLElement>('.js-actions-runner-instructions')!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const downloadUrl = target.getAttribute('data-download-url')!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const filename = target.getAttribute('data-download-filename')!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const token = target.getAttribute('data-download-token')!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const hash = target.getAttribute('data-download-hash')!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const os = target.getAttribute('data-download-os')!

    for (const el of selection.querySelectorAll('.js-action-runner-url')) {
      el.textContent = downloadUrl
    }

    for (const el of selection.querySelectorAll('.js-action-runner-filename')) {
      el.textContent = filename
    }

    for (const el of selection.querySelectorAll('.js-action-runner-token')) {
      el.textContent = token
    }

    for (const el of selection.querySelectorAll('.js-action-runner-hash')) {
      el.textContent = hash
    }
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const architecture = target.getAttribute('data-download-architecture')!
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    selection.querySelector<HTMLElement>('.js-actions-runner-windows-arm64-preview')!.hidden = !(
      os === 'win' && architecture === 'arm64'
    )
    updateUrlParams('arch', architecture)
  },
  {capture: true},
)

function updateUrlParams(key: string, value: string) {
  const urlParams = new URLSearchParams(window.location.search)
  urlParams.set(key, value)

  const url = new URL(window.location.href, window.location.origin)
  url.search = urlParams.toString()
  updateUrl(url.toString())
}
